/* eslint-disable eqeqeq */
import { Dispatch } from "redux";
import { LOCAL_PATH, RESULT_CODE, STATUS_VM } from "../../constant";
import navService from "../../routers/nav.service";
import { vendingMachineService } from "../../service/vendingmachine.service";
import { FGetState } from "../app.reducer";
import vmType from "./vendingmachine.type";

const updateStatusVM = (
    status: string,
) => {
    return async (dispatch: Dispatch, _getState: FGetState) => {
        dispatch({
            type: vmType.GET_VM_INFO.UP_STATUS,
            payload: status,
        });
    };
};

const getListVendingByToroGo = (param: any) => {
    return async (dispatch: Dispatch, _getState: FGetState) => {
        try {
            const req = { data: param };
            let res = await vendingMachineService.getListVendingByToroGo(req);
            return res;
        } catch (err) {

        }
    };
};

const getVendingInfoByToroGo = (param: any, isCallAPI: boolean) => {
    return async (dispatch: Dispatch, getState: FGetState) => {
        dispatch({
            type: vmType.GET_VM_INFO.LOADING
        });
        try {
            const req = { data: param };
            // Kiểm tra get data từ local hay db
            if (isCallAPI) {
                let res = await vendingMachineService.getVendingInfoByToroGo(req);
                if (res.resultCode == RESULT_CODE.FAIL) {
                    const codeStore = localStorage.getItem("code");
                    localStorage.setItem(`vendingInfo_${codeStore}`, JSON.stringify(res.data?.vendingMachine));
                    if (res.message == STATUS_VM.NO_INTERNET) {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.NO_INTERNET}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    } else if (res.message == STATUS_VM.STATUS_MAINTENANCED) {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.STATUS_MAINTENANCED}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    } else if (res.message == STATUS_VM.STATUS_FILL_GOODS) {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.STATUS_FILL_GOODS}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    } else if (res.message == STATUS_VM.STATUS_NOT_READY_GOODS) {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.STATUS_NOT_READY_GOODS}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    }
                    else if (res.message == STATUS_VM.OFFLINE) {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.OFFLINE}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    }
                    else {
                        let queryStr = localStorage.getItem(`queryString`);
                        let queryString = queryStr.concat(`&status=${STATUS_VM.VM_OPENING_SOON}`);
                        navService.push(LOCAL_PATH.STATUS_VM.concat(queryString));
                    }
                    dispatch({
                        type: vmType.GET_VM_INFO.CLEAN,
                    });
                } else {
                    dispatch({
                        type: vmType.GET_VM_INFO.SUCCESS,
                        payload: res.data?.vendingMachine,
                    });
                }
            } else {
                const codeStore = localStorage.getItem("code");
                let cachedVMInfo = localStorage.getItem(`vendingInfo_${codeStore}`);
                if (cachedVMInfo) {
                    var data = JSON.parse(cachedVMInfo);
                    dispatch({
                        type: vmType.GET_VM_INFO.SUCCESS,
                        payload: data,
                    });
                }
            }
        } catch (err) {
            dispatch({
                type: vmType.GET_VM_INFO.ERROR,
                error: err,
            });
        }
    };
};

const getAdvertiseByToroGo = (param: any, isCallAPI: boolean) => {
    return async (dispatch: Dispatch, getState: FGetState) => {
        dispatch({
            type: vmType.ADVERTISE.LOADING
        });
        try {
            const req = { data: param };
            // Kiểm tra get data từ local hay db
            if (isCallAPI) {
                let res = await vendingMachineService.getAdvertiseByToroGo(req);
                if (res.resultCode == RESULT_CODE.FAIL) {
                    dispatch({
                        type: vmType.ADVERTISE.ERROR,
                    });
                } else {
                    dispatch({
                        type: vmType.ADVERTISE.SUCCESS,
                        payload: res.data?.advertiseList,
                    });
                }
            } else {
                const codeStore = localStorage.getItem("code");
                let cachedAds = localStorage.getItem(`advertise_${codeStore}`);
                if (cachedAds) {
                    var data = JSON.parse(cachedAds);
                    dispatch({
                        type: vmType.ADVERTISE.SUCCESS,
                        payload: data,
                    });
                }
            }
        } catch (err) {
            dispatch({
                type: vmType.ADVERTISE.ERROR,
                error: err,
            });
        }
    };
};

const updateSyncData = (param: any) => {
    return async (dispatch: Dispatch, getState: FGetState) => {
        dispatch({
            type: vmType.SYNC_DATA.LOADING
        });
        try {
            const req = { data: param };
            await vendingMachineService.updateSyncData(req);
        } catch (err) {
            dispatch({
                type: vmType.SYNC_DATA.ERROR,
                error: err,
            });
        }
    };
};


const cleanVendingInfoByToroGo = () => {
    return async (dispatch: Dispatch, _getState: FGetState) => {
        dispatch({
            type: vmType.GET_VM_INFO.CLEAN,
        });
    };
};

const cleanAdvertiseByToroGo = () => {
    return async (dispatch: Dispatch, _getState: FGetState) => {
        dispatch({
            type: vmType.ADVERTISE.CLEAN,
        });
    };
};

const getOrderMachineInfo = (param: any, isCallAPI: boolean) => {
    return async (dispatch: Dispatch, getState: FGetState) => {
        dispatch({
            type: vmType.GET_ORDER_INFO.LOADING
        });
        try {
            const req = { data: param };
            // Kiểm tra get data từ local hay db
            if (isCallAPI) {
                let res = await vendingMachineService.getOrderMachineInfo(req);
                const codeStore = localStorage.getItem("code");
                localStorage.setItem(`orderInfo_${codeStore}`, JSON.stringify(res.data?.listMachine || []));
                dispatch({
                    type: vmType.GET_ORDER_INFO.SUCCESS,
                    payload: res.data?.listMachine || [],
                });
            } else {
                const codeStore = localStorage.getItem("code");
                let cachedOrderInfo = localStorage.getItem(`orderInfo_${codeStore}`);
                if (cachedOrderInfo) {
                    var data = JSON.parse(cachedOrderInfo);
                    dispatch({
                        type: vmType.GET_ORDER_INFO.SUCCESS,
                        payload: data || [],
                    });
                }
            }
        } catch (err) {
            dispatch({
                type: vmType.GET_ORDER_INFO.ERROR,
                error: err,
            });
        }
    };
};

export default {
    updateStatusVM,
    getVendingInfoByToroGo,
    getListVendingByToroGo,
    getAdvertiseByToroGo,
    cleanVendingInfoByToroGo,
    cleanAdvertiseByToroGo,
    updateSyncData,
    getOrderMachineInfo,
} as const;